export default __webpack_public_path__ + "images/5a2695e91aa6b763b0048ad35a973f0b.png";